import { popupController } from "./popupController";
import { icitTabs } from "./icitTabs";
import { icitGMap } from "./icitGMap";
import { atLocationSaver } from "./atLocationSaver";
import { icitSlider } from "./icitSlider";
import { atriaGTMTracker } from "./atriaGTMTracker";

export const websiteController = ($) => {
  const classes = [];
  const sliders = [];
  let careersPagiRequest = null;
  $.getStylesheet = function (href) {
    var $d = $.Deferred();
    var $link = $("<link/>", {
      rel: "stylesheet",
      type: "text/css",
      href: href,
    }).appendTo("head");
    $d.resolve($link);
    return $d.promise();
  };
  $.debounce = window.Cowboy.debounce;
  const init = () => {
    window.gtmDidInit = false;
    $(document).one("mousemove click keyup keydown scroll", initLateComponents);

    registerFunctions();
    loadScripts();
    initActions();
    initClicks();
    initTabs();
    initMaps();
    maybeTrigger404Popup();
  };

  const registerFunctions = function () {
    $.fn.isInViewport = function () {
      const elementTop = $(this).offset().top;
      const elementBottom = elementTop + $(this).outerHeight();

      const viewportTop = $(window).scrollTop();
      const viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
  };

  const maybeTrigger404Popup = function () {
    if ("?not_found=1" === window.location.search) {
      const html =
        '<div class="404-popup-inner" style="background: #fff; padding: 20px 60px;text-align: center;"><h3>Sorry, that page cannot be found.</h3><p>Please try to search for another career.</p></div>';
      const popup = new popupController(html);
      popup.show();
    }
  };

  const initGTM = function () {
    if (window.gtmDidInit) {
      return false;
    }
    window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      dataLayer.push({
        event: "gtm.js",
        "gtm.start": new Date().getTime(),
        "gtm.uniqueEventId": 0,
      });
    }; // this part ensures PageViews is always tracked
    script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-TS6ZLT4";

    document.head.appendChild(script);

    classes.push(new atriaGTMTracker());
  };

  const initMaps = function () {
    if ("object" === typeof window.initIcitMaps) {
      $.getScript(
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDOMuvH6b4Zde0shsLn4EubWEIEjW-r2nE&libraries=drawing",
        function () {
          window.initIcitMaps.forEach(function (mapData) {
            new icitGMap(mapData.selector, mapData.markers);
          });
        }
      );
    }
  };

  const initTabs = function () {
    const tabs = $(".tabs-header .tabs-navi");
    if (tabs.length > 0) {
      tabs.each(function () {
        new icitTabs($(this));
      });
    }
  };

  const initActions = function () {
    $(window)
      .on("resize", $.debounce(200, websiteResizeDebounced))
      .on("scroll", $.debounce(20, websiteScrollDebounced));

    $(document).on("resize_debounced", mobileSliders);

    if ($(".search-results-box .careers-list").length > 0) {
      $(".search-results-box .careers-list").scroll(
        $.debounce(20, maybeLoadNextCareersPage)
      );
    }
  };

  const initClicks = function () {
    $("body")
      .on("click", "header .hamburger", showMenu)
      .on("click", "header .close-mob-menu", hideMenu)
      .on("submit", "form.filter-form", buildNewUrlOnSubmit)
      .on("submit", "form.career-search", buildNewSearchUrlOnSubmit)
      .on("focusin", ".filter-form input", filterInputFocused)
      .on("change", ".filter-form select", filterSelectChanged)
      .on(
        "click",
        ".filter-form .location a.populate-current-location",
        populateLocationWithCurrent
      )
      .on("click", ".mobile-show-map", toggleMap)
      .on("click", ".btn-map-desktop", toggleMapDesktop)
      .on("click", ".btn-mobile-filter", showMobileFilter)
      .on("click", ".toogle-video-popup", videoCtaPopup)
      .on("click", "a[atria-toggle-popup]", toggleLinkPopup)
      .on(
        "keydown",
        "ul#menu-header-menu li.menu-item-has-children",
        maybeShowHideMenuOnEnterKey
      )

      .on("click", ".show-cookies-osano", function (e) {
        e.preventDefault();
        window.Osano.cm.showDoNotSell()
      });
  };

  const loadScripts = function () {
    $.getScript(
      "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",
      initSliders
    );
    $.getStylesheet(
      "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
    );
  };

  const initLateComponents = function () {
    initGTM();
    $(document).off("mousemove click keyup keydown scroll", initLateComponents);
    $.getScript(
      "https://code.jquery.com/jquery-migrate-3.0.0.min.js",
      function () {
        $.getScript(
          "https://code.jquery.com/ui/1.11.4/jquery-ui.min.js",
          jquiLoaded
        );
      }
    );

    $.getScript(
      "https://cdnjs.cloudflare.com/ajax/libs/js-cookie/2.2.1/js.cookie.min.js",
      cookieLibLoaded
    );
  };

  const cookieLibLoaded = function () {
    classes.push(new atLocationSaver());
  };

  const initSliders = function () {
    const sliderElements = $("[icit-slider]");
    sliderElements.each(function () {
      let slider = $(this);
      sliders.push(new icitSlider(slider));
    });

    const brandsSlider = $(
      "body.home .brands-list:not(.slick-initialized),.slider-brands .brands-list:not(.slick-initialized)"
    );
    if (brandsSlider.length > 0) {
      brandsSlider.each(function () {
        const sliderBrand = $(this);
        sliderBrand.slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    }

    $(document).trigger("resize_debounced");
  };

  const maybeShowHideMenuOnEnterKey = function (e) {
    const liItem = $(this);
    if (13 === e.keyCode) {
      liItem.find(".sub-menu").toggle();
    }
  };

  const showMenu = function (e) {
    e.preventDefault();
    const btn = $(this);
    const menu = btn.parent().find(".a-header-menu");
    const btnClose = btn.parent().find(".close-mob-menu");
    const banner = $(".apply-now-sticky-banner");
    if (banner) {
      banner.hide();
    }
    const mobileFacButton = $(".fac-mobile");
    if (mobileFacButton) {
      mobileFacButton.hide();
    }

    menu
      .stop()
      .css({ display: "flex", transform: "translateY(-100%)", "z-index": 10 })
      .animate(
        { "z-index": 110 },
        {
          step: function (now, fx) {
            $(this).css({
              transform: "translateY(" + Math.round(now - 110) + "%)",
            });
          },
          duration: "slow",
        },
        "linear"
      );

    btnClose.show();
  };

  const hideMenu = function (e) {
    e.preventDefault();
    const btn = $(this);
    const menu = btn.parent().find(".a-header-menu");
    const banner = $(".apply-now-sticky-banner");
    if (banner) {
      banner.show();
    }
    const mobileFacButton = $(".fac-mobile");
    if (mobileFacButton) {
      mobileFacButton.show()
    }
    menu.hide();
    btn.hide();
  };

  const jquiLoaded = function () {
    const autocompleteLocation = $('form.career-search input[name="location"]');
    if (autocompleteLocation.length > 0) {
      autocompleteLocation.autocomplete({
        source: window.searchFormAutocomplete,
        appendTo: autocompleteLocation.parent(),
      });
    }

    const autocompleteLocationFilter = $(
      "form.filter-form .form-row.location input"
    );
    if (autocompleteLocationFilter.length > 0) {
      autocompleteLocationFilter.autocomplete({
        source: window.searchFormAutocomplete,
        appendTo: autocompleteLocationFilter.parent(),
      });
    }
  };

  const buildNewUrlOnSubmit = function (e) {
    e.preventDefault();
    const form = $(this);

    const userArea = form.find('input[name="user_area"')?.val() ?? "";
    const brand = form.find('input[name="brand"')?.val() ?? "";
    const keywords = form.find('input[name="keywords"').val();
    const location = form.find('input[name="location"]').val();
    const jobCat = form.find('select[name="job_cat"]').val();

    let url = window.location.origin + at_settings.website_prefix + "careers";

    if (brand.length > 0) {
      url += "/brand/" + brand;
    }

    if (jobCat.length > 0 && "0" != jobCat) {
      url += "/category/" + jobCat;
    }

    if (location.length > 0) {
      url += "/location/" + encodeURIComponent(location);
    }

    const urlObj = new URL(url);

    url += "/";

    if (keywords.length > 0) {
      urlObj.searchParams.append("keywords", keywords);
    }

    if (userArea.length > 0) {
      urlObj.searchParams.append("user_area", userArea);
    }

    window.location.href = urlObj.href;
  };

  const buildNewSearchUrlOnSubmit = function (e) {
    e.preventDefault();
    const form = $(this);

    const keywords = form.find('input[name="keywords"').val();
    const location = form.find('input[name="location"]').val();
    const category = form.find('select[name="job_cat"]').val();
    let url = at_settings.website_prefix + "careers";

    if (category.length > 1) {
      url += "/category/" + encodeURIComponent(category);
    }

    if (location.length > 0) {
      url += "/location/" + encodeURIComponent(location);
    }

    url += "/";

    if (keywords.length > 0) {
      url += "?keywords=" + keywords;
    }

    window.location.href = url;
  };

  const filterSelectChanged = function () {
    const el = $(this);
    if (el.parents(".filter-popup").length > 0) {
      return;
    }
    const form = el.closest("form");
    form.submit();
  };

  const filterInputFocused = function (e) {
    const el = $(this);
    if (el.parents(".filter-popup").length > 0) {
      return;
    }

    const value = el.val();

    el.one("focusout", function (e) {
      const _el = $(this);
      const _value = _el.val();
      if (_value === value) {
        return;
      }
      const form = el.closest("form");
      form.submit();
    });
  };

  const populateLocationWithCurrent = function (e) {
    e.preventDefault();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        currentPositionSuccess,
        currentPositionError,
        { timeout: 10000 }
      );
    } else {
      const errorHtml =
        '<div style="padding: 30px;background: #fff;">Geolocation is not supported by this browser</div>';
      const popup = popupController(errorHtml);
      popup.show();
    }
  };

  const currentPositionSuccess = function (position) {
    $.ajax({
      url: window.location.origin + "/wp-admin/admin-ajax.php",
      data: {
        action: "get_zip_from_coords",
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      },
      dataType: "json",
      success: function (response) {
        if (true === (response.status ?? "")) {
          setUserCurrentLocation(response.data ?? "");
        }
      },
    });
  };

  const setUserCurrentLocation = function (locationText) {
    const inp = $('.filter-form .form-row.location input[name="location"]');
    if (inp.length > 0) {
      inp.val(locationText);
    }
  };

  const currentPositionError = function () {
    const errorHtml =
      '<div style="padding: 30px;background: #fff;">Please allow access to locations in your browser.</div>';
    const popup = new popupController(errorHtml);
    popup.show();
  };

  const toggleMap = function (e) {
    e.preventDefault();
    const map = $("#search-map");
    const btn = $(this);
    if (map.hasClass("visible")) {
      map.stop().slideUp();
      map.removeClass("visible");
      btn.text("Show Map");
    } else {
      map.stop().slideDown();
      map.addClass("visible");
      btn.text("Hide Map");
    }
  };

  const toggleMapDesktop = function (e) {
    e.preventDefault();
    const map = $("#search-map");
    const selectAreaBtn = $(".btn-map-select-area");
    const btn = $(this);
    if (map.hasClass("hidden")) {
      map.stop().slideDown();
      map.removeClass("hidden");
      btn.text("Hide Map");

      if (selectAreaBtn.length > 0) {
        selectAreaBtn.removeAttr("style");
      }
    } else {
      map.stop().slideUp();
      map.addClass("hidden");
      btn.text("Show Map");

      if (selectAreaBtn.length > 0) {
        selectAreaBtn.attr("style", "display: none !important;");
      }
    }
  };

  const showMobileFilter = function (e) {
    e.preventDefault();
    let filterHtml = $("form.filter-form");
    if (filterHtml.length > 0) {
      filterHtml = filterHtml.get(0).outerHTML;
      const popup = new popupController(filterHtml);
      popup.show();
      popup.addClass("filter-popup");

      const autocompleteLocationFilter = $(
        ".filter-popup form.filter-form .form-row.location input"
      );
      if (autocompleteLocationFilter.length > 0) {
        autocompleteLocationFilter.autocomplete({
          source: window.searchFormAutocomplete,
          appendTo: autocompleteLocationFilter.parent(),
        });
      }
    }
  };

  const websiteResizeDebounced = function () {
    $(document).trigger("resize_debounced");
  };

  const mobileSliders = function () {
    if (window.innerWidth > 767) {
      const iconTextRowsUnslick = $(".icon_text-row.slick-initialized");
      if (iconTextRowsUnslick.length > 0) {
        iconTextRowsUnslick.slick("unslick");
      }

      const jobOpeningsUnslick = $(".job-openings-holder.slick-initialized");
      if (jobOpeningsUnslick.length > 0) {
        jobOpeningsUnslick.slick("unslick");
      }

      return;
    }

    const iconTextRows = $(".icon_text-row:not(.slick-initialized)");
    if (iconTextRows.length > 0) {
      iconTextRows.each(function () {
        const itemTextrow = $(this);

        itemTextrow.slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    }

    const jobOpenings = $(".job-openings-holder:not(.slick-initialized)");
    if (jobOpenings.length > 0) {
      jobOpenings.each(function () {
        var job_opening = $(this);

        job_opening.slick({
          dots: true,
          arrows: false,
          infinite: true,
          // speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          swipeToSlide: true,
        });
      });
    }
  };

  const maybeLoadNextCareersPage = function () {
    if (null !== careersPagiRequest) {
      return;
    }

    if (!$("body").hasClass("post-type-archive-careers")) {
      return;
    }

    const pagination = $(".pagination");
    const careersList = $(".search-results-box .careers-list");
    if (careersList.length <= 0) {
      return;
    }

    if (window.innerWidth > 768) {
      if (careersList.get(0).scrollHeight > careersList.height()) {
        if (
          $(".search-results-box .careers-list").scrollTop() +
            careersList.height() <
          careersList.get(0).scrollHeight - 10
        ) {
          return;
        }
      } else {
        if (!pagination.isInViewport()) {
          return;
        }
      }
    } else {
      if (!pagination.isInViewport()) {
        return;
      }
    }

    const nextLink = pagination.find("a.next.page-numbers");
    if (nextLink.length <= 0) {
      return;
    }

    const url = nextLink.attr("href");
    careersPagiRequest = $.ajax({
      url,
      beforeSend: function () {
        $(".search-results-box").addClass("blocked");
      },
      complete: function () {
        $(".search-results-box").removeClass("blocked");
      },
      success: function (response) {
        window.history.pushState({}, "", url);

        const htmlObj = $(response);
        const pagi = htmlObj.find(".pagination");
        if (pagi.length > 0) {
          $(".pagination").replaceWith(pagi);
        }

        const jobRow = htmlObj.find(".careers-list .container .job-row");
        if (jobRow.length > 0) {
          $(".careers-list .container .job-row").append(jobRow.html());
        }

        careersPagiRequest = null;
      },
    });
  };

  const websiteScrollDebounced = function (e) {
    maybeLoadNextCareersPage();
  };

  const videoCtaPopup = function (e) {
    e.preventDefault();
    const href = $(this).attr("href");
    if (href.length <= 0) {
      return;
    }
    const html =
      '<video src="' +
      href +
      '" style="width: 100%;max-width: 50vw;aspect-ratio: 1.77;" controls="" autoplay="true"></video>';
    const popup = new popupController(html);
    popup.show();
  };

  const toggleLinkPopup = function (e) {
    e.preventDefault();
    const link = $(this);
    const popupId = link.attr("atria-toggle-popup");
    if (popupId.length <= 0) {
      return;
    }

    const popupElement = $(popupId);
    if (popupElement.length <= 0) {
      return;
    }

    const html = popup.html();
    const popup = new popupController(html);
    popup.getObject().find(".popup-inner").css({
      background: "#fff",
      padding: "15px",
      "padding-top": "40px",
    });
    popup.show();
  };

  init();
  return {
    classes,
    sliders,
    careersPagiRequest,
    popupController,
  };
};
